/** Compute min, max, median, and p90 from an array of numbers */
export function computeStats(values: number[]): { min: number; max: number; median: number; p90: number } | null {
  if (values.length === 0) return null;

  const sorted = [...values].sort((a, b) => a - b);
  const min = sorted[0];
  const max = sorted[sorted.length - 1];

  const mid = Math.floor(sorted.length / 2);
  const median = sorted.length % 2 === 0
    ? (sorted[mid - 1] + sorted[mid]) / 2
    : sorted[mid];

  const p90Index = Math.ceil(sorted.length * 0.9) - 1;
  const p90 = sorted[Math.min(p90Index, sorted.length - 1)];

  return { min, max, median, p90 };
}
